var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLive(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 7.577,
    r: 3.077,
    fill: "currentColor"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.144 20.17v.791H4.987v-.79h2.157zm-1.79-3.474v4.265H4.325v-4.265h1.029zm4.008 0v4.265H8.337v-4.265h1.025zm3.03 3.26l.888-3.26h1.152l-1.439 4.265h-.744l.143-1.004zm-.805-3.26l.888 3.26.149 1.006h-.753l-1.43-4.266h1.146zm6.786 3.474v.791h-2.274v-.79h2.274zm-1.907-3.474v4.265h-1.029v-4.265h1.029zm1.614 1.693v.765H16.1v-.765h1.98zm.302-1.693v.794h-2.283v-.794h2.283z",
    fill: "currentColor"
  })));
}
export default SvgLive;